import './styles.css';
import { GAME_NAME } from '@sa/sim';
import { App } from './ui/app';

document.title = GAME_NAME;
new App(document.getElementById('app')!).start();
